import React from 'react'

const CigaretteIcon = props => (
  <svg viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g opacity="0.5">
      <path
        d="M9.69436 5.02815H9.0831V6.25068H9.69436C9.87774 6.25068 10 6.12843 10 5.94505V5.33379C10 5.15041 9.87774 5.02815 9.69436 5.02815Z"
        fill="url(#paint0_linear)"
      />
      <path d="M8.47178 5.02815H2.66476V6.25068H8.47178V5.02815Z" fill="url(#paint1_linear)" />
      <path
        d="M0.219727 5.33379V5.94505C0.219727 6.12843 0.34198 6.25068 0.525359 6.25068H2.35915V5.02815H0.525359C0.34198 5.02815 0.219727 5.15041 0.219727 5.33379Z"
        fill="url(#paint2_linear)"
      />
      <path
        d="M9.29715 4.32521C9.7556 3.89733 9.84729 3.19437 9.29715 2.6748C9.02208 2.39973 9.05264 2.12466 9.29715 1.88016C9.4194 1.7579 9.4194 1.57452 9.29715 1.45227C9.1749 1.33002 8.99152 1.33002 8.86926 1.45227C8.41081 1.88016 8.31912 2.58311 8.86926 3.10268C9.29715 3.53057 8.86926 3.86677 8.86926 3.89733C8.74701 4.01958 8.74701 4.20296 8.86926 4.32521C8.99152 4.44747 9.1749 4.44747 9.29715 4.32521Z"
        fill="url(#paint3_linear)"
      />
      <path
        d="M7.52429 2.88874C7.52429 3.10268 7.34091 3.28606 7.34091 3.28606C7.21866 3.40831 7.21866 3.59169 7.34091 3.71395C7.46317 3.8362 7.64655 3.8362 7.7688 3.71395C7.79936 3.68338 8.13556 3.34719 8.13556 2.88874C8.13556 2.6748 8.07443 2.36917 7.7688 2.06353C7.49373 1.78846 7.52429 1.51339 7.7688 1.26889C7.89105 1.14664 7.89105 0.963256 7.7688 0.841003C7.64655 0.71875 7.46317 0.71875 7.34091 0.841003C6.88246 1.26889 6.79077 1.97184 7.34091 2.49142C7.46317 2.61367 7.52429 2.73592 7.52429 2.88874Z"
        fill="url(#paint4_linear)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="9.54155"
        y1="5.02815"
        x2="9.54155"
        y2="6.25068"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="5.56827"
        y1="5.02815"
        x2="5.56827"
        y2="6.25068"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="1.28944"
        y1="5.02815"
        x2="1.28944"
        y2="6.25068"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="9.08321"
        y1="1.36058"
        x2="9.08321"
        y2="4.4169"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1="7.54874"
        y1="0.749313"
        x2="7.54874"
        y2="3.80564"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
)

export default CigaretteIcon
